import { ActionCreator, AjaxDispatcher } from "./ajax-dispatcher";

export default class ProductOrdering {
    private baseElement: HTMLElement;
    private listComponentName: string;
    private defaultListComponentName = "ProductList";
    private sortSelectElement: HTMLSelectElement;
    currentOrderingValue: string;
    buttons: any[];
    actionName = 'order';
    defaultOrderingValue = 'default';

    constructor(baseElement: HTMLElement) {
        this.baseElement = baseElement;
        this.listComponentName = this.baseElement.getAttribute('data-list-component');
        if (!this.listComponentName) {
            this.listComponentName = this.defaultListComponentName;
        }
        this.sortSelectElement = this.baseElement.querySelector('[data-component-part="sort-option-selector"]');
    }

    init() {
        const buttonNodeList = this.baseElement.querySelectorAll(`[data-action="${this.actionName}"]`);
        if (!buttonNodeList)
            return;

        this.buttons = [...buttonNodeList];
        this.buttons.forEach(b => b.addEventListener('click', (event: any) => this.onButtonClick(event)));

        this.initButtons();
        this.initSelect();
    }

    private initButtons() {
        const queryParams = this.getQueryParams();
        this.setCurrentOrdering(queryParams[this.actionName]);
    }

    private initSelect() {
        this.sortSelectElement.addEventListener('change', () => this.sortingSelected());
    }

    private sortingSelected(): any {
        const orderingValue: string = this.sortSelectElement.value as string;
        if (!orderingValue || orderingValue === this.currentOrderingValue)
            return;

        this.applyOrdering(orderingValue);
    }

    private onButtonClick(event: any) {
        event.preventDefault();

        const target = event.target;

        if (!target || target.dataset.action !== this.actionName)
            return;

        const orderingValue: string = target.dataset.param;
        if (!orderingValue || orderingValue === this.currentOrderingValue)
            return;

        this.applyOrdering(orderingValue);
    }

    private applyOrdering(orderingValue: string) {
        this.setCurrentOrdering(orderingValue);
        const queryParams = this.getQueryParams();
        if (orderingValue === this.defaultOrderingValue) {
            delete queryParams[this.actionName];
        } else {
            queryParams[this.actionName] = orderingValue;
        }

        const queryString = this.buildQueryString(queryParams);

        const action = new ActionCreator().reloadProductListAction(queryString, this.listComponentName);
        new AjaxDispatcher().dispatchGetAction(action);
    }

    private setCurrentOrdering(orderingValue: string) {
        if (!orderingValue)
            orderingValue = this.defaultOrderingValue;
        this.selectButton(orderingValue);
        this.setSelection(orderingValue);
        this.currentOrderingValue = orderingValue;
    }

    private getQueryParams(): { [key: string]: any; } {
        const paramPart: string = window.location.search.replace('?', '');
        const paramSplit: string[] = paramPart ? paramPart.split('&') : [];
        const params: { [key: string]: any; } = {};
        paramSplit.map(p => p.split('=')).forEach(kv => params[kv[0]] = kv[1]);
        return params;
    }

    private buildQueryString(params: { [x: string]: any; }): string {
        const query = Object.keys(params)
            .map(k => k + '=' + params[k])
            .join('&');
        return query;
    }

    private selectButton(orderingValue: string) {
        this.buttons.forEach((button: any) => {
            button.classList.toggle('selected', button.dataset.param === orderingValue);
        });
    }

    private setSelection(orderingValue: string) {
        if (this.sortSelectElement) {
            this.sortSelectElement.value = orderingValue;
        }
    }
}
